import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gtm-opt-in-segments',
  templateUrl: './gtm-opt-in-segments.component.html',
  styleUrls: ['./gtm-opt-in-segments.component.scss']
})
export class GtmOptInSegmentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
